import { defaultDemoUser } from './types.js';
export const DEMO_URL = 'https://demo.supabase.local';
export const issueSeed = [
    { id: 1, title: 'Review onboarding flow', status: 'open', description: null, priority: 1 },
    { id: 2, title: 'Confirm messaging copy', status: 'in-progress', description: 'Needs legal review', priority: 2 },
    { id: 3, title: 'Publish release checklist', status: 'done', description: null, priority: 3 },
];
export const labelSeed = [
    { id: 1, name: 'docs', issue_id: 1 },
    { id: 2, name: 'release', issue_id: 3 },
];
export const tables = {
    issues: {
        name: 'issues',
        columns: [
            { name: 'id', type: 'integer', nullable: false, hasDefault: true },
            { name: 'title', type: 'text', nullable: false, hasDefault: false },
            { name: 'status', type: 'text', nullable: false, hasDefault: false },
            { name: 'description', type: 'text', nullable: true, hasDefault: false },
            { name: 'priority', type: 'integer', nullable: false, hasDefault: true },
        ],
    },
    labels: {
        name: 'labels',
        columns: [
            { name: 'id', type: 'integer', nullable: false, hasDefault: true },
            { name: 'name', type: 'text', nullable: false, hasDefault: false },
            { name: 'issue_id', type: 'integer', nullable: true, hasDefault: false },
        ],
    },
};
export function getTable(name, tableMap = tables) {
    return Object.prototype.hasOwnProperty.call(tableMap, name) ? tableMap[name] : undefined;
}
export function getColumn(table, name) {
    return table.columns.find((column) => column.name === name);
}
export const issueBoardSchemaSql = `
CREATE TABLE issues (
  id SERIAL PRIMARY KEY,
  title TEXT NOT NULL,
  status TEXT NOT NULL CHECK (status IN ('open', 'in-progress', 'done')),
  description TEXT,
  priority INTEGER NOT NULL DEFAULT 0
);

CREATE TABLE labels (
  id SERIAL PRIMARY KEY,
  name TEXT NOT NULL UNIQUE,
  issue_id INTEGER REFERENCES issues(id)
);
`;
export async function seedIssueBoard(db) {
    const issueParams = issueSeed.flatMap((issue) => [
        issue.id,
        issue.title,
        issue.status,
        issue.description,
        issue.priority,
    ]);
    const issueValues = issueSeed
        .map((_, index) => `($${index * 5 + 1}, $${index * 5 + 2}, $${index * 5 + 3}, $${index * 5 + 4}, $${index * 5 + 5})`)
        .join(', ');
    await db.query(`INSERT INTO issues (id, title, status, description, priority) VALUES ${issueValues}`, issueParams);
    await db.query(`SELECT setval('issues_id_seq', (SELECT COALESCE(MAX(id), 0) FROM issues), true)`);
    const labelParams = labelSeed.flatMap((label) => [label.id, label.name, label.issue_id]);
    const labelValues = labelSeed
        .map((_, index) => `($${index * 3 + 1}, $${index * 3 + 2}, $${index * 3 + 3})`)
        .join(', ');
    await db.query(`INSERT INTO labels (id, name, issue_id) VALUES ${labelValues}`, labelParams);
    await db.query(`SELECT setval('labels_id_seq', (SELECT COALESCE(MAX(id), 0) FROM labels), true)`);
}
export async function seedInvalidIssueBoard(db) {
    await db.query(`INSERT INTO issues (id, title, status, description, priority) VALUES ($1, $2, $3, $4, $5)`, [1, null, 'open', null, 1]);
}
export const issueBoardDefinition = {
    schemaSql: issueBoardSchemaSql,
    seed: seedIssueBoard,
    tables,
    user: defaultDemoUser,
};
export const invalidIssueBoardDefinition = {
    schemaSql: issueBoardSchemaSql,
    seed: seedInvalidIssueBoard,
    tables,
    user: defaultDemoUser,
};
export async function initializeSchema(db) {
    await db.exec(issueBoardSchemaSql);
}
export async function seedDatabase(db) {
    await seedIssueBoard(db);
}
